import { Component, OnInit } from '@angular/core';
import { IntegrationService } from '../../../services/integration.service';

@Component({
  selector: 'app-fb-integations',
  templateUrl: './fb-integations.component.html',
  styleUrls: ['./fb-integations.component.scss']
})
export class FbIntegationsComponent implements OnInit {
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  public sortBy: string = "";
  public sortOrder: string = "desc";

  constructor(private integrationService:IntegrationService) { }

  ngOnInit() {
    this.integrationService.getAll()
      .subscribe((data:any)=> {
        this.data = data.data;
        console.log(this.data);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/integrations/fb-integations/fb-integations.component.ts